import React, { useState, useEffect } from "react";
import Topbar from "../components/Menu/Topbar";
import Header from "../components/Menu/Header";
import Footer from "../components/Menu/Footer";
import Favicon from "../components/Head/Faviconscript";

export default function DefaultLayout({ children, websiteData }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Favicon
        favicon={websiteData?.website?.favicon}
        scripts={websiteData?.website?.script}
      />
      <Topbar websiteData={websiteData} />
      {websiteData && (
        <div
          className={`sticky top-0 z-50 w-full transition-all duration-300 ${
            scrolled ? "bg-white" : "bg-transparent"
          }`}
        >
          <Header websiteData={websiteData} />
        </div>
      )}
      <main>{children}</main>
      {websiteData && <Footer websiteData={websiteData} />}
    </>
  );
}
